import React, { useState } from 'react'
import cn from 'classnames'
import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowBack, ArrowForward } from '@material-ui/icons'

export interface PaginatorProps {
  totalPages: number
  currentPage: number
  onPageChange: (page: number) => void
  onNext?: (page: number) => void
  onPrev?: (page: number) => void
}

export const Paginator: React.FC<PaginatorProps> = ({ totalPages, currentPage, onPageChange, onNext, onPrev }) => {
  const [nextDisabled, setNextDisabled] = useState(false)
  const [previousDisabled, setPreviousDisabled] = useState(false)

  const classes = useStyles()
  const arr = new Array(totalPages).fill(0)

  const handlePrevious = () => {
    if (currentPage > 0 && !previousDisabled) {
      setPreviousDisabled(true)
      setTimeout(() => {
        setPreviousDisabled(false)
      }, 300)
      if (onPrev) {
        onPrev(currentPage - 1)
      }
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (currentPage < totalPages - 1 && !nextDisabled) {
      setNextDisabled(true)
      setTimeout(() => {
        setNextDisabled(false)
      }, 300)
      if (onNext) {
        onNext(currentPage + 1)
      }
      onPageChange(currentPage + 1)
    }
  }

  return (
    <div className={classes.root}>
      <IconButton
        className={classes.arrow}
        style={{ visibility: currentPage !== 0 ? 'visible' : 'hidden' }}
        onClick={handlePrevious}
        disableRipple={true}
      >
        <ArrowBack fontSize='large' />
      </IconButton>
      <div className={classes.pages}>
        {arr.map((_, i) => (
          <IconButton
            key={i}
            className={cn(classes.pageButton, { selected: i === currentPage })}
            onClick={() => onPageChange(i)}
            disableRipple={true}
          >
            <div className={classes.page} />
          </IconButton>
        ))}
      </div>
      <IconButton
        className={classes.arrow}
        style={{ visibility: currentPage !== totalPages - 1 ? 'visible' : 'hidden' }}
        onClick={handleNext}
        disableRipple={true}
      >
        <ArrowForward fontSize='large' />
      </IconButton>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  pages: {
    display: 'flex',
    marginLeft: 10,
    marginRight: 10
  },
  page: {
    width: 32,
    height: 2,
    backgroundColor: 'rgba(0, 0, 0, .5)'
  },
  pageButton: {
    width: 40,
    height: 40,
    padding: 0,

    '&.selected $page': {
      backgroundColor: 'black',
      height: 6,
      marginTop: -3
    }
  },
  arrow: {
    color: 'black'
  }
}))
